import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGem = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m40.454 24-5.67 9H13.216l-5.671-9 5.67-9h21.567zM36.44 36 44 24l-7.561-12H11.561L4 24l7.561 12z" })
});
export default SvgGem;
